import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import GeneralDialog from '../GeneralDialog';
import PropTypes from 'prop-types';
import ArbitratorFeeCalculator from '../ArbitrationFeeCalculator';
import ArbitrationProcedure from '../ArbitrationProcedure';
import ClausesAgreement from '../ClausesAgreement';
import ArbitrationAgreement from '../ArbitrationAgreement';
import ArbitrationRules from '../ArbitrationRules';
import ArbitrationList from '../ArbitrationList';
import AboutOnlineArbitration from '../AboutOnlineArbitration';
import ArbitrationListForView from '../ArbitrationListForView';
const aboutOnlineArbitration = <AboutOnlineArbitration />;
const arbitrationList = <ArbitrationList />;
const arbitrationListForView = <ArbitrationListForView />;
const arbitrationRules = <ArbitrationRules />;
const arbitrationProcedures = <ArbitrationProcedure />;
const arbitrationAgreement = <ArbitrationAgreement />;
const onlineArbitrationClauses = <ClausesAgreement />;
const arbitratorFeeCalculator = <ArbitratorFeeCalculator />;


const styles =  (theme) => ({
    list: {
      width: 250,
      marginLeft:'10px',
      marginRight:'10px'
    },
    fullList: {
      width: 'auto',
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4,
    },
    link: {
      textDecoration: 'none',
    },
});

class SideDrawerMain extends Component{
    
  state = {
    openCaseFileList: false,
    openOnlineArbitrationList: false,
    openSettingList: false,
  };

  handleClick = (openList) => {
    this.setState(state => ({ [openList]: !state[openList] }));
  };

  
  render(){
    const { classes, toggleDrawer, openDrawer} = this.props;
    // const { openCaseFileList, openOnlineArbitrationList, openSettingList } = this.state;
    const usefulItemsTitles = ['About Online Arbitration', 'Arbitrator’s List', 'Arbitration Rules', 'Arbitration Procedure', 'Arbitration Agreement', 'Online Arbitration Clauses', 'Arbitration Fee Calculator'];
    const usefulItemsTitles2 = ['', '', '', '', '(Parties to an existing dispute in which neither an arbitration clause nor a previous agreement with respect to arbitration exists, may sign the following agreement to refer such dispute to arbitration through our Online Arbitration Platform)', 'The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS’s Online Arbitration Platform:', ''];
    const usefulItemsDialogs = [aboutOnlineArbitration, arbitrationListForView, arbitrationRules, arbitrationProcedures, arbitrationAgreement, onlineArbitrationClauses, arbitratorFeeCalculator];
     
    const sideList = (props) => (
      <div className={classes.list}>
        <List  component="nav">
            {
                usefulItemsTitles.map((title, index) => (
                    // <UsefulItemDialog key={index}>
                        <GeneralDialog key={index} title={title} title2={usefulItemsTitles2[index]} component={usefulItemsDialogs[index]} location='landingPage'/>
                    //</UsefulItemDialog>   
                ))
            }
            
        </List>
      </div>
    );

    return(
      <div>
        <Drawer anchor="right" open={openDrawer} onClose={toggleDrawer('left', false)}>
          <div
              tabIndex={0}
              role="button"
              //onClick={toggleDrawer('right', false)}
              //onKeyDown={toggleDrawer('right', false)}
          >
              {sideList(toggleDrawer)}
          </div>
        </Drawer>
      </div>
  );
  }
    
}


SideDrawerMain.contextTypes = {
  t: PropTypes.func
}

export default withStyles(styles)(SideDrawerMain);